module.exports = __webpack_public_path__ + "static/img/img_product_renwufabu@2x.73edd99.png";


//////////////////
// WEBPACK FOOTER
// ./static/pc/产品服务/img_product_renwufabu@2x.png
// module id = Tsgk
// module chunks = 0